import React from 'react'
import PropTypes from 'prop-types'
import QRCode from 'react-qr-code'

import { FormModal } from '../basicForm/FormModal'

export const QRCodeForm = ({
  defaultData,
  envData,
  isLocalEnvironment,
  modSchema,
  openEditFormModal,
  setOpenEditFormModal,
  listKey,
  selectEditFormModal,
  openFormEdit,
  isViewOnly,
  setIsViewOnly,
  isStaff,
}) => {
  return (
    <div className="trtui-card" style={{ padding: 0 }}>
      <div className="trtui-card-body">
        <>
          <div className="trtui-row">
            <div className="trtui-col-lg-12">
              <div className="trtui-card">
                <div className="trtui-card-body">
                  <div className="trtui-text-center">{`Manage your ${isStaff ? 'Check-In/Out (Logout & login to see the changed passcode.)' : 'Pickup/Drop Passcodes'}`}</div>
                </div>
              </div>
            </div>
            <div className={`trtui-col-lg-${isStaff ? '12' : '6'}`}>
              <div className="trtui-card">
                <div className="trtui-card-body">
                  <div className="trtui-text-center">
                    <div className="trtui-row trtui-justify-content-center">
                      <div className="trtui-col-lg-9">
                        <h4 className="trtui-mt-4 trtui-fw-semibold">
                          {defaultData.formData[modSchema.displayName]}
                        </h4>
                        <div className="trtui-mt-4">
                          <button
                            type="button"
                            className="trtui-btn trtui-btn-primary"
                            data-bs-toggle="modal"
                            data-bs-target="#exampleModal"
                            onClick={() =>
                              openFormEdit(isStaff ? defaultData.formData : defaultData.formData[0])
                            }
                          >
                            Passcode
                          </button>
                        </div>
                      </div>
                    </div>
                    <div className="trtui-row trtui-justify-content-center trtui-mt-4 trtui-mb-2">
                      <div className="trtui-col-12">
                        <QRCode value={`code`} />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {openEditFormModal && selectEditFormModal !== null && (
            <FormModal
              id={listKey}
              envData={envData}
              setOpenFormModal={setOpenEditFormModal}
              isLocalEnvironment={isLocalEnvironment}
              formSchema={modSchema.modalForm}
              modSchema={modSchema.modalForm}
              defaultData={selectEditFormModal}
              isViewOnly={isViewOnly}
              setIsViewOnly={setIsViewOnly}
            />
          )}
        </>
      </div>
    </div>
  )
}

QRCodeForm.propTypes = {
  defaultData: PropTypes.object,
  envData: PropTypes.object,
  isLocalEnvironment: PropTypes.string,
  modSchema: PropTypes.object,
  openEditFormModal: PropTypes.object,
  setOpenEditFormModal: PropTypes.object,
  listKey: PropTypes.object,
  selectEditFormModal: PropTypes.object,
  openFormEdit: PropTypes.object,
  isViewOnly: PropTypes.object,
  setIsViewOnly: PropTypes.object,
  isStaff: PropTypes.bool,
}
